namespace advisorop.services {
    `use strict`;

    export class AcgHelper {

        constructor() {
        }

        /**
         * converts number to string which can be sortable when added to other string value
         * @param val
         */
        numToSortableStr(val) {
            // get rid of decimal places
            let tmp = 1e15 + Math.round(Math.abs(val * 100)) + "";
            if (val < 0) {
                // must be less than positive numbers
                return "000000000000000" + tmp;
            }

            return tmp;
        }

        /**
          * sort value can be agregate values e.g. market value, %, open date, etc...
          * @param rowData
          * @param sortByField
          * @param accounts
          */
        calcSortableFieldValue(rowData: any, sortByField: string, accounts: any): string {

            let keySortByField = rowData[sortByField];

            //special treatment for agregate columns
            if (sortByField == "usdMarketValue") {

                keySortByField = accounts.filter(item => item.accountId === rowData.accountId && item.groupId === rowData.groupId)
                    .reduce((acctValue, current) => acctValue + current.usdMarketValue, 0);

                keySortByField = this.numToSortableStr(keySortByField);
            }

            return keySortByField;
        }

        /**
         * some columns use the same value for sorting e.g.market value and their %
         * @param columnName
         */
        mapSummaryGridSortColumn(columnName: string): string {
            if (columnName === "modelDescription" || columnName === "accountId") {
                return "level3Caption";
            } else if (columnName === "sleevePercentageOfAG" || columnName === "sleevePercentageOfHH") {
                return "usdMarketValue";
            } else {
                return columnName;
            }
        }


        /**
         * selects row by given Key
         * @param rowKey
         * @param dgSummary
         */
        selectDgSummaryRow(rowKey: any, dgSummary: DevExpress.ui.dxDataGrid) {

            //console.log("RowKey to RowIndex", rowKey);
            const rowInd = dgSummary.getRowIndexByKey(rowKey);

            //console.log("Searching grid row element for:", rowInd);
            //only if we found RowIndex otherwise this will be -1
            if (rowInd >= 0) {
                const rowEl = dgSummary.getRowElement(rowInd);
                $(rowEl).addClass("acsrow");
            }
        }

        calcSummaryRowIndex(level: string, rowData: any, sortByField: string, rootLevel: string, accounts: any): any {

            //console.log('Calc. summary row index...');

            let rowKey: any = (rootLevel === "R") ? [rowData.groupId] : [rowData.householdId];
            let expandRowKey: any = [rowData.householdId];


            //H level: householdId
            //R level: householdId, groupId
            //A level: householdId, groupId, disp. val. accountID 
            //S level: householdId, groupId, accountId, boModelId  (if boModelId > 0)

            let keySortByField = this.calcSortableFieldValue(rowData, sortByField, accounts);

            const accVal = `${keySortByField}-${rowData.level3Caption}-${rowData.accountId}`;

            if (level == "H") {
                rowKey = [rowData.householdId];
                expandRowKey = [rowData.householdId];
            } else if (level == "R") {
                rowKey = (rootLevel === "R") ? [rowData.groupId] : [rowData.householdId, rowData.groupId];
                expandRowKey = (rootLevel === "R") ? [rowData.groupId] : [rowData.householdId];
            } else if (level == "A") {
                rowKey = (rootLevel === "R") ? [rowData.groupId, accVal] : [rowData.householdId, rowData.groupId, accVal];
                expandRowKey = (rootLevel === "R") ? [rowData.groupId] : [rowData.householdId, rowData.groupId];
            } else if (level == "S") {
                expandRowKey = (rootLevel === "R") ? [rowData.groupId, accVal] : [rowData.householdId, rowData.groupId, accVal];
                rowKey = {
                    householdId: rowData.householdId,
                    groupId: rowData.groupId,
                    accountId: rowData.accountId,
                    boModelId: rowData.boModelId
                };
            }

            //console.log("Row index: ", rowKey);

            return {
                rowKey,
                expandRowKey
            };
        }

        //main method which will find and select correct row in a data grid
        syncDgSummaryGridSelection(level: string, rowData: any, sortByField: string, rootLevel: string, dgSummary: DevExpress.ui.dxDataGrid, accounts: any) {

            //console.log(`Sync SummaryGrid. rootLevel: ${rootLevel}, sortBy: ${sortByField}`, dgSummary);

            const rowKeys: { rowKey, expandRowKey } = this.calcSummaryRowIndex(level, rowData, sortByField, rootLevel, accounts);

            if (rowKeys) {
                //console.log("RowKeys", rowKeys);

                // first we need to expand sleeves
                if (level == "S") {
                    //expand row before select
                    dgSummary.expandRow(rowKeys.expandRowKey).then(vv => {
                        setTimeout(() => this.selectDgSummaryRow(rowKeys.rowKey, dgSummary), 100);
                    }, err => console.log(`Error during ExpandRow of dgHouseholds widget...`));
                } else {
                    this.selectDgSummaryRow(rowKeys.rowKey, dgSummary);
                }
            }
        }

    }
    angular.module(Constants.ADVOP_SERVICES).service("acgHelper", AcgHelper);
}